module.exports = __webpack_public_path__ + "img/Sumarville.df545638.png";